export type Platform = "Desktop" | "Mobile" | "Mobile HJ App";

export const detectPlatform = (): Platform => {
  // Check if mobile device
  const userAgent = navigator.userAgent;
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  // Check if we're in HJ context (already stored in Redux/localStorage)
  const displayContext = localStorage.getItem("rkDisplayContext");
  const isHJContext = displayContext === "hj";

  if (isHJContext && isMobile) {
    return "Mobile HJ App";
  }

  return isMobile ? "Mobile" : "Desktop";
};

// React hook version for components
export const usePlatform = (): Platform => {
  return detectPlatform();
};
